import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { PaymentInProgressTextContainer } from './StyledComponents';
import { getBadgeFontSize } from '../helpers';

type Props = {
  docWidth: number;
};

const PaymentInProgressBadge: React.FC<Props> = ({ docWidth }) => {
  return (
    <PaymentInProgressTextContainer fontSize={getBadgeFontSize(docWidth)}>
      <FormattedMessage id="tooltip.paymentInProgress" defaultMessage="Payment in progress" />
    </PaymentInProgressTextContainer>
  );
};

export default memo(PaymentInProgressBadge);
